import React from 'react';
import styled from 'styled-components';
import Summary from "./Summary";
import Prescription from "../../Prescription/Prescription";
import Reference from "./Reference";
import Certificate from "../../../components/Certificate";


interface ChatMessageProps {
  message: string;
  timestamp: string;
  isDoctor: boolean;
  imageUrl?: string; 
  fileName?: string; 
}


const MessageContainer = styled.div<{ isDoctor?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isDoctor }) => (isDoctor ? 'flex-start' : 'flex-end')};
  margin: 10px;
`;

const MessageBubble = styled.div<{ isDoctor?: boolean }>`
  background-color: ${({ isDoctor }) => (isDoctor ? '#e0f7fa' : '#d1c4e9')};
  color: black;
  padding: 10px;
  border-radius: 8px;
  max-width: 70%;
`;

const Timestamp = styled.span`
  font-size: 12px;
  color: gray;
  margin-top: 4px;
`;

const ChatHistoryMessage: React.FC<ChatMessageProps> = ({ message, timestamp, isDoctor, imageUrl, fileName }) => {
  let parsedMessage: any;

  try {
    parsedMessage = JSON.parse(message);
  } catch {
    parsedMessage = message;
  }

  const isObjectMessage = typeof parsedMessage === "object" && parsedMessage !== null;

  return (
    <MessageContainer isDoctor={isDoctor}>
      <MessageBubble isDoctor={isDoctor}>
        {imageUrl ? (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt={fileName || "Image"}
              style={{ maxWidth: "200px", maxHeight: "200px", borderRadius: "8px" }}
            />
          </a>
        ) : isObjectMessage ? (
          parsedMessage?.type === "new-summary" ? (
            parsedMessage?.["type-summary"] === "soap" ? (
              <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Summary summary={parsedMessage.message} />
              </div>
            ) : 
            parsedMessage?.["type-summary"] === "prescription" ? 
            (
              <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Prescription summary={parsedMessage.message} />
              </div>
            ) : 
            parsedMessage?.["type-summary"] === "reference" ? 
            ( 
              <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Reference summary={parsedMessage.message} />
              </div>

            ) :
            parsedMessage?.["type-summary"] === "certificate" ? 
            ( 
              <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Certificate summary={parsedMessage.message} />
              </div>

            )
            : null
          
          ) : (
            <div>{parsedMessage?.message}</div>
          )
        ) : (
          <span>{typeof parsedMessage === "object" ? parsedMessage?.message : parsedMessage}</span>
        )}
      </MessageBubble>
      <Timestamp>{timestamp}</Timestamp>
    </MessageContainer>
  );
  
};

export default ChatHistoryMessage;
